import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ProjectDataTypes } from '@mono/proto-clients';
import { SpecraButton } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { Plus } from 'lucide-react';
import { useState } from 'react';
import { useTablePreferences } from '../../../../hooks/useTablePreferences';
import { EntityTable } from '../../../Delivery/_shared/components/EntityTable';
import { EmptyState } from '../../../Delivery/_shared/components/PageStates';
import { AiAssistButton } from '../../AiAssist';
import { WORKSTREAM_COLUMNS } from '../../CaptureDetailPage';
import { WorkstreamSheet } from '../../entitySheets';
import { useCaptureWorkspace } from '../../hooks';
import { usePursuitRecord } from '../PursuitRecordContext';
import { PursuitSectionFrame } from '../PursuitSectionFrame';
/** Workstreams (Working papers): the workstream item table and sheet, moved from the tab. */ export function WorkstreamsSection() {
    const { captureProjectId, zouProjectId, capabilities, correlationId } = usePursuitRecord();
    const { data } = useCaptureWorkspace(captureProjectId);
    const prefs = useTablePreferences('ts:capture:workstreams');
    const [sheet, setSheet] = useState({
        open: false,
        value: null
    });
    return /*#__PURE__*/ _jsxs(PursuitSectionFrame, {
        actions: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(AiAssistButton, {
                    action: "draft-workstream",
                    label: "Draft analysis",
                    prompt: "Help me make progress on this capture's workstreams. Suggest concrete items for customer shaping, solutioning, black hat, and teaming, prioritized for where this pursuit is now.",
                    zouProjectId: zouProjectId
                }),
                capabilities.canEdit && /*#__PURE__*/ _jsx(SpecraButton, {
                    "data-testid": Testids.capture.addWorkstreamItemButton,
                    iconLeft: /*#__PURE__*/ _jsx(Plus, {
                        className: "h-4 w-4"
                    }),
                    onClick: ()=>setSheet({
                            open: true,
                            value: null
                        }),
                    size: "sm",
                    children: "New item"
                })
            ]
        }),
        title: "Workstreams",
        children: [
            /*#__PURE__*/ _jsx(EntityTable, {
                columns: WORKSTREAM_COLUMNS,
                data: data?.workstreamItems ?? [],
                emptyState: /*#__PURE__*/ _jsx(EmptyState, {
                    description: "Capture structured work across the 8 capture workstreams.",
                    title: "No workstream items"
                }),
                filters: prefs.filters,
                onFilterChange: prefs.setFilter,
                onRowClick: (r)=>setSheet({
                        open: true,
                        value: r
                    }),
                onToggleSort: prefs.toggleSort,
                rowKey: (r)=>r.id,
                rowTestid: Testids.capture.workstreamItemRow,
                sort: prefs.sort,
                testid: Testids.capture.workstreamTable
            }),
            /*#__PURE__*/ _jsx(WorkstreamSheet, {
                captureProjectId: captureProjectId,
                correlationId: correlationId,
                item: sheet.value,
                onOpenChange: (open)=>setSheet((s)=>({
                            ...s,
                            open
                        })),
                open: sheet.open,
                workstreamType: ProjectDataTypes.CaptureWorkstreamType.CUSTOMER_SHAPING
            })
        ]
    });
}
